// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getAnalytics } from 'firebase/analytics'; // optional

const firebaseConfig = {
  apiKey: "AIzaSyBhPk034uz-x_E5vewJDGAD35cYN-kE4FI", // keep your real key here
  authDomain: "heydiari.com",
  projectId: "lakbaymag",
  storageBucket: "lakbaymag.firebasestorage.app",
  messagingSenderId: "875210557925",
  appId: "1:875210557925:web:c0216efba3b94d273a870c",
  measurementId: "G-1MCJ84GZNP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app); // optional

// Auth setup
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);

const db = getFirestore(app);

export { db };
export default app;